/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import SearchIcon from '@material-ui/icons/Search';
import styles from './BulkSearchBar.module.css';

const BulkSearchBar = ({
  searchQuery,
  setSearchQuery,
  filterArray,
  setFilterSelections,
  filterSelections,
  setDisabled,
}) => {
  const [data, setData] = useState([]);
  const ref = useRef(null);
  const removeChip = (index) => {
    let value;
    setData((prev) => {
      const newData = prev.slice();
      value = newData.splice(index, 1);
      return [...newData];
    });

    setFilterSelections((prevs) => {
      const copySet = new Set(prevs);
      if (copySet?.delete(...value)) {
        return copySet;
      }
      return new Set([...copySet]);
    });
  };

  const addBulkValues = (e) => {
    if (e.key === 'Enter') {
      const dataList = searchQuery.split(/\n/);
      const index = dataList.indexOf('');
      if (index > -1) {
        dataList.splice(index, 1);
      }
      const invalid = dataList.filter((item) => filterArray.indexOf(item) === -1);
      const valid = dataList.filter((n) => !invalid.includes(n));
      setData(() => {
        const final = [
          ...new Set(invalid),
          ...new Set(valid),
          ...new Set(data),
        ];
        return [...final];
      });

      setSearchQuery('');
    }

  };

  useEffect(() => {
    const array = Array.from(filterSelections);
    setData((prev) => [...prev, ...array]);
    setFilterSelections(new Set(array));
  }, []);

  useEffect(() => {
    const found = filterArray.filter((val) => data.includes(val));
    if (found.length > 0)
      return setFilterSelections((prev) => {
        const copySet = new Set(prev);
        found.map((value) => {
          if (copySet.add(value)) {
            return copySet;
          }
          return value;
        });
        return new Set([...copySet, ...found]);
      });
    return found;
  }, [data]);

  useEffect(() => {
    const arr = data.filter((item) => filterArray.indexOf(item) === -1);
    // eslint-disable-next-line no-unused-expressions
    !arr.length ? setDisabled(false) : setDisabled(true);
  }, [data, filterArray]);

  return (
    <div
      className={clsx(styles.searchBarContainer)}
      onClick={() => ref.current.focus()}
    >
      <div className={styles.bulkSearchContainer}>
        {data?.map((chip, index) => (
          <div
            className={
              filterArray.includes(chip) ? styles.chip : styles.chipError
            }
          >
            <div className={styles.chipText}>{chip}</div>
            <button
              type='button'
              style={
                filterArray.includes(chip)
                  ? { color: ' #3177B6' }
                  : { color: '#ffffff' }
              }
              className={styles.chipCloseButton}
              onClick={() => removeChip(index)}
            >
              &#10006;
            </button>
          </div>
        ))}
      </div>
      <div className={styles.searchInput}>
        <textarea
          name='body'
          className={styles.input}
          value={searchQuery}
          placeholder='To search multiple values hit enter.'
          onInput={(e) => setSearchQuery(e.target.value?.trimStart())}
          onKeyDown={(e) => addBulkValues(e)}
          type='textarea'
          id='header-search'
          data-testid='header-search'
          autoComplete='off'
          ref={ref}
        />
        {!searchQuery && <SearchIcon className={styles.icon} />}
      </div>
    </div>
  );
};

BulkSearchBar.propTypes = {
  searchQuery: PropTypes.string,
  setSearchQuery: PropTypes.func.isRequired,
  filterArray: PropTypes.array,
  setFilterSelections: PropTypes.func,
  filterSelections: PropTypes.object,
  setDisabled: PropTypes.func,
};

export default BulkSearchBar;
